export const mainRow = {
	"Detection Time": {"field": "report_date", "header": "TIME", "sort": true, "defaultSortValue": false},
	"Hostname": {"field": "Hostname", "header": "HOSTNAME", "sort": true, "defaultSortValue": false},
	"Severity": {"field": "Severity", "header": "SEVERITY", "sort": true, "defaultSortValue": false},
	"Title": {"field": "Title", "header": "TITLE", "sort": true, "defaultSortValue": false},
	"Description": {"field": "Description", "header": "DESCRIPTION", "sort": true, "defaultSortValue": false}
}